// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"576d310c","779":"27e8263c"}[chunkId] + ".chunk.js";
};